"use client";

import { createQueryClient } from "@shared/lib/query-client";
import {
	type DehydratedState,
	HydrationBoundary,
	type QueryClient,
	QueryClientProvider,
} from "@tanstack/react-query";
import type { PropsWithChildren } from "react";

let clientQueryClientSingleton: QueryClient;
function getQueryClient() {
	if (typeof window === "undefined") {
		return createQueryClient();
	}

	if (!clientQueryClientSingleton) {
		clientQueryClientSingleton = createQueryClient();
	}

	return clientQueryClientSingleton;
}

interface ApiClientProviderProps extends PropsWithChildren {
	dehydratedState?: DehydratedState;
}

export function ApiClientProvider({
	children,
	dehydratedState,
}: ApiClientProviderProps) {
	const queryClient = getQueryClient();
	const content = dehydratedState ? (
		<HydrationBoundary state={dehydratedState}>
			{children}
		</HydrationBoundary>
	) : (
		children
	);

	return (
		<QueryClientProvider client={queryClient}>
			{content}
		</QueryClientProvider>
	);
}
